<script>
import ExpandedRow from '@lib/layouts/table/features/expanded-row'

export default {
  name: 'FeedActivityContent',
  components: {
    ExpandedRow,
  },
  props: {
    row: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    counts() {
      try {
        return JSON.parse(this.row.counts)
      } catch (error) {
        // console.error(error)
      }
      return {}
    },
  },
}
</script>

<template>
  <expanded-row :columns="columns">
    <div slot="expanded-row-cell-1">
      <div :class="$style.subrow">
        Offers created: {{ counts.offers_created }}
      </div>
      <div :class="$style.subrow">
        Offers deleted: {{ counts.offers_deleted }}
      </div>
      <div :class="$style.subrow">
        Offers updated: {{ counts.offers_updated }}
      </div>
    </div>

    <div slot="expanded-row-cell-2">
      <div :class="$style.subrow">
        Merchants created: {{ counts.merchants_created }}
      </div>
      <div :class="$style.subrow">
        Merchants deleted: {{ counts.merchants_deleted }}
      </div>
      <div :class="$style.subrow">
        Merchants updated: {{ counts.merchants_updated }}
      </div>
    </div>
  </expanded-row>
</template>

<style lang="scss" module>
.subrow {
  margin-bottom: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
